window.config = {
    VUE_APP_STAGING: process.env.VUE_APP_STAGING,
    VUE_APP_API_URL: process.env.VUE_APP_API_URL,
};
